/**
 * read-capabilities-view (US-AI-0322-S01 · @UC9415 @UC9400) — VIEW admin của năng lực ĐỌC.
 *
 * VÌ SAO TỒN TẠI (bug PO 28/07): màn admin "Năng lực AI" chỉ đọc `AI_CAPABILITY_CATALOG` — 18 usecase
 * **100% `tier:"write"`** (form ghi). Năng lực ĐỌC sống ở `READ_TOOL_REGISTRY`, **0 endpoint admin nào
 * chạm tới** ⇒ người vận hành không có cách nào biết trợ lý trả lời được "nhóm có những ai" hay "ai
 * chưa nộp", ngoài việc đọc source. Năng lực CÓ THẬT mà bề mặt quan sát im lặng — cùng họ với 3 ca
 * DP-5 đã vá (`member_list` thiếu manifest, `expense_list` thiếu registry, `send_reminder` khai sai).
 *
 * 🔴 CHỈ HIỂN THỊ — KHÔNG toggle. QĐ PO 17/07 (`read-tool-registry.ts:22-25`) giữ nguyên: registry đọc
 * LUÔN BẬT, không toggle per-group (tắt `member_list` chẳng bảo vệ gì — user vẫn xem trên GUI — chỉ
 * làm trợ lý ngu đi). Vì vậy `alwaysOn` là hằng `true` theo KIỂU, không phải cột dữ liệu bật/tắt:
 * trạng thái "năng lực đọc đã tắt" KHÔNG BIỂU DIỄN ĐƯỢC. Muốn đảo quyết định đó ⇒ hỏi PO, không lẻn
 * một cờ boolean vào đây.
 *
 * 🔴 DẪN XUẤT, KHÔNG CHÉP TAY: mọi field sinh từ `READ_TOOL_REGISTRY` — thêm tool ở registry là view
 * tự có, không cần sửa file này. Chép tay danh sách ở đây = tái tạo đúng mẫu hình "guard canh nhầm
 * chỗ" (kiểm DANH SÁCH TAY thay vì tự khám phá) đã cắn repo ba lần.
 *
 * HÀM THUẦN (DP-3): KHÔNG DB, KHÔNG I/O, KHÔNG LLM.
 */

import type { QueryReportKind } from "./query-intent.js";
import { READ_TOOL_REGISTRY } from "./read-tool-registry.js";

/** Một năng lực ĐỌC hiển thị cho admin (read-only — không có field bật/tắt, có chủ đích). */
export interface AiReadCapabilityView {
  /** Tên tool = `QueryReportKind` — mã ổn định cho client/test. */
  readonly toolName: QueryReportKind;
  /** Mô tả NGUYÊN VĂN từ registry — admin đọc ĐÚNG chuỗi LLM đọc (hai bản = hai sự thật ⇒ drift). */
  readonly descriptionVi: string;
  /** `read` = chỉ đọc, 0 bút toán. Registry KHÔNG được chứa write-tool (spec khoá). */
  readonly tier: "read";
  /** Cần KỲ (YYYY-MM) mới trả lời được; thiếu ⇒ trợ lý HỎI LẠI, không đoán. */
  readonly requiresPeriod: boolean;
  /** Chọn được quỹ cụ thể (LLM chọn trong tập ĐÓNG server đã duyệt — xem `pickAllowedFundId`). */
  readonly supportsFund: boolean;
  /** LUÔN BẬT (QĐ PO 17/07). Kiểu `true` ⇒ không có đường biểu diễn trạng thái tắt. */
  readonly alwaysOn: true;
}

/** Dựng 1 lần lúc load module — dữ liệu tất định, không phụ thuộc runtime. */
const READ_CAPABILITY_VIEW: readonly AiReadCapabilityView[] = Object.freeze(
  READ_TOOL_REGISTRY.map((tool) =>
    Object.freeze({
      toolName: tool.name,
      descriptionVi: tool.description,
      tier: "read" as const,
      requiresPeriod: tool.required.includes("period"),
      supportsFund: tool.optional?.includes("fund") === true,
      alwaysOn: true as const,
    }),
  ),
);

/** Danh mục năng lực ĐỌC cho màn admin — đóng băng, phủ đúng bằng `READ_TOOL_REGISTRY`. */
export function listReadCapabilities(): readonly AiReadCapabilityView[] {
  return READ_CAPABILITY_VIEW;
}
